<template>
    <main>
        <div class="box">
            <div class="mark" @click="toggleScoreDetail"></div>
            <div class="content">
                <div class="close" @click="toggleScoreDetail"></div>
                <div class="title">积分明细</div>
                <div class="line"></div>
                <div class="list">
                    <div class="item" v-for="item in list">
                        <div class="left tit">
                            <div class="middle">{{item.title}}</div>
                        </div>
                        <div class="right stat">
                            <div class="middle">
                                <div class="num">{{item.type == 1 ? '+' : '-'}}{{item.score}}</div>
                                <div class="time">{{tool.date.formatDate('Y-m-d H:i:s',item.create_time)}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="footer">{{footer == 1 ? "上拉加载更多" : footer == 2 ?  "加载中" : "没有更多内容了"}}</div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    export default {
        name: 'score-detail',
        data() {
            return {
                list:[],
                footer:1,
                page:1,
            }
        },
        components:{

        },
        computed:{

        },
        methods: {
            toggleScoreDetail(){
                this.$emit('toggleScoreDetail')
            },
            getScoreList(){
                if(this.footer != 1){return false;}
                this.footer = 2;
                this.http.request({
                    api:"user/getUserScore",
                    data:{
                        page:this.page
                    },
                    success:(res)=>{
                        this.list = this.list.concat(res.list);
                        if(res.list.length < res.limit){
                            this.footer = 3;
                        }else{
                            this.footer = 1;
                            this.page = this.page + 1;
                        }
                    }
                })
            }
        },
        mounted() {
            this.query = this.$route.query;
            this.getScoreList();
        },
        destroyed() {

        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .box{position: fixed;top:0;left:0;width: 100%;height:100%;z-index: 100;
        .mark{position: absolute;top:0;left:0;width: 100%;height:100%;background: rgba(0,0,0,.8)}
        .content{width:720px;height:380px;padding: 30px 10px 10px; background: #fff;position:absolute;top:50%;left:50%;transform: translate(-50%,-50%);border-radius: 2px;
            .close{width: 40px;height:40px;position: absolute;top:0;right:0;background: url("~@/assets/image/53.png") no-repeat center center;background-size: 20px;cursor: pointer;transition: background .3s ease;}
            .close:hover{background-color: #0176ce;background-image:url("~@/assets/image/54.png");background-size: 20px; transition: background .3s ease;}
            .title{font-size: 26px;text-align: center;}
            .line{width: 110px;height:4px;margin: 5px auto 0; background: url("~@/assets/image/30.png") no-repeat center center;background-size: 100% 100%;}
            .list{padding:0 40px;height:280px;overflow: hidden;overflow-y: auto;margin-top: 20px;
                .item{height:50px;border-bottom: 1px solid #bfddf3;
                    .middle{width: 450px;height:50px;font-size: 14px;}
                }
                .stat{width: 160px;
                    .num{font-size: 14px;color:#0176ce;}
                    .time{font-size: 12px;color:#929292;margin-top: 5px;}
                }
                .footer{height:50px;line-height: 50px;text-align: center;font-size: 14px;color:#999;}
            }
            .list::-webkit-scrollbar{width:10px;background-color: #e1e2e2;border-radius: 5px;}
            .list::-webkit-scrollbar-thumb{background-color: #0176ce;border-radius: 5px;}
        }
    }
</style>

